import Arbor from '../../arbor'
import { ActivePage } from '../../enums/ActivePage'
import State from './State'

const LoadingController = new class {

    async start() {

        State.content = await fetch(`/fast/loading-page/${ Arbor.store('state').visitorId }`)
            .then(response => response.json())
            .then(data => data.data.view)

        Arbor.store('qv').navigation.activePage = ActivePage.Loading
        Arbor.store('qv').navigation.goToLoadingSteps()

    }

}()

export default LoadingController
